// ======================================================================
// FILE: src/modules/wms/dashboard/components/DashboardKpiGrid.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Dashboard KPI Grid
//
// DATA SOURCE:
//   WMSDashboardPage -> GET /api/wms/dashboard
// ======================================================================

import React from "react";

import DashboardKpiCard
  from "./DashboardKpiCard";


// ======================================================================
// COMPONENT
// ======================================================================

export default function DashboardKpiGrid({
  data = {}
}) {


  // ====================================================================
  // KPI DATA
  //
  // Backend fields:
  //
  //   open_works
  //   in_progress
  //   completed
  //   overdue
  //   due_today
  //   pending_approval
  //   my_works
  //   watching
  //
  // ====================================================================

  const cards = [

    {
      title: "Open Works",

      value:
        data?.open_works ?? 0,

      trend:
        data?.open_works_trend
        ?? "",

      trendType:
        data?.open_works_trend_type,

      icon:
        "fas fa-folder-open",

      borderColor:
        "#0d6efd",

      iconColor:
        "#0d6efd",
    },


    {
      title: "In Progress",

      value:
        data?.in_progress ?? 0,

      trend:
        data?.in_progress_trend
        ?? "",

      trendType:
        data?.in_progress_trend_type,

      icon:
        "fas fa-spinner",

      borderColor:
        "#fd7e14",

      iconColor:
        "#fd7e14",
    },


    {
      title: "Completed",

      value:
        data?.completed ?? 0,

      trend:
        data?.completed_trend
        ?? "",

      trendType:
        data?.completed_trend_type,

      icon:
        "fas fa-check-circle",

      borderColor:
        "#198754",

      iconColor:
        "#198754",
    },


    {
      title: "Overdue",

      value:
        data?.overdue ?? 0,

      trend:
        data?.overdue_trend
        ?? "",

      trendType:
        data?.overdue_trend_type
        ?? "down",

      icon:
        "fas fa-exclamation-circle",

      borderColor:
        "#dc3545",

      iconColor:
        "#dc3545",
    },


    {
      title: "Due Today",

      value:
        data?.due_today ?? 0,

      trend:
        data?.due_today_trend
        ?? "Today's Work",

      icon:
        "fas fa-calendar-day",

      borderColor:
        "#6f42c1",

      iconColor:
        "#6f42c1",
    },


    {
      title: "Pending Approval",

      value:
        data?.pending_approval ?? 0,

      trend:
        data?.pending_approval_trend
        ?? "Need Attention",

      trendType:
        data?.pending_approval_trend_type
        ?? "down",

      icon:
        "fas fa-user-check",

      borderColor:
        "#20c997",

      iconColor:
        "#20c997",
    },


    {
      title: "My Works",

      value:
        data?.my_works ?? 0,

      trend:
        data?.my_works_trend
        ?? "Assigned",

      icon:
        "fas fa-user",

      borderColor:
        "#6610f2",

      iconColor:
        "#6610f2",
    },


    {
      title: "Watching",

      value:
        data?.watching ?? 0,

      trend:
        data?.watching_trend
        ?? "Monitoring",

      icon:
        "fas fa-eye",

      borderColor:
        "#6c757d",

      iconColor:
        "#6c757d",
    },

  ];


  // ====================================================================
  // RENDER
  // ====================================================================

  return (

    <div className="row g-3 mb-4">

      {cards.map(
        (card, index) => (

          <div
            className="
              col-12
              col-sm-6
              col-lg-3
              col-xxl
            "
            key={index}
          >

            <DashboardKpiCard

              {...card}

              onClick={() => {}}

            />

          </div>

        )
      )}

    </div>

  );

}